import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import notifications from 'notifications';
import {getStore} from 'redux-stores/Store';
import {getLegacyRequestObjectName} from 'requests/RequestConstants';

import * as RequestTemplateDAO from './RequestTemplateDAO';
import {createRequestTemplateCompleted} from './RequestTemplateReduxActions';

export async function createRequestTemplate(requestSchemaId: string): Promise<void> {
  const {requestSchema, template} = await RequestTemplateDAO.createRequestTemplate(requestSchemaId);
  AppDispatcher.dispatch({
    actionType: EventConstants.ASSAY_SCHEMA_FETCHED,
    assaySchema: requestSchema,
  });
  getStore().dispatch(createRequestTemplateCompleted(template));
  notifications.success(`Created ${getLegacyRequestObjectName({lowerCase: true})} template successfully`);
}
